// extracted by mini-css-extract-plugin
export default {"ppe-icon-actions":"Sites_ppe-icon-actions__knwkz","edit":"Sites_edit__k8Pro","delete":"Sites_delete__Ds-fW"};